import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'
import GoogleAdsPreviewList from './GoogleAdsPreviewList'
import GoogleAssetGroupEdit from '../../../../forms/Google/AdForms/GoogleAssetGroup/GoogleAssetGroupEdit'
import AdGoogleEdit from '../../../../forms/Google/AdForms/AdGoogleEdit'

import { getAssetGroups, clearAssetGroups } from '../../../../modules/actions/assets'
import { getAds, clearAds } from '../../../../modules/actions/ads'
import { selectedGoogleAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../modules/selectors/partnerships'
import { assetGroupsSelector } from '../../../../modules/selectors/assets'
import { adsSelector } from '../../../../modules/selectors/ads'

import { GOOGLE_PLATFORM } from '../../../../constants/selectLists/platformList'
import { LIFETIME_DATE_PRESET } from '../../../../constants/selectLists/listItemFiltersList'

const GoogleAdsSection = () => {
  const dispatch = useDispatch()

  const assetGroups = useSelector(assetGroupsSelector)
  const ads = useSelector(adsSelector)
  const { id: googleAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const partnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  // pass only internal asset groups to GoogleAssetGroupsPreviewList for approval
  const internalAssetGroups = assetGroups.filter(({ resource_name }) => !resource_name)
  const internalAds = ads.filter(({ approval_status }) => approval_status === 'pending_approval')

  const getInternalAdsData = useCallback(() => {
    dispatch(
      getAssetGroups({
        internal: true,
        rights_holder_account_id: partnershipRightsHolderId,
        detail: true,
        approval_status: 'pending_approval'
      })
    )
  }, [dispatch, partnershipRightsHolderId])

  useEffect(() => {
    dispatch(
      getAds(
        {
          internal: true,
          rights_holder_account_id: partnershipRightsHolderId,
          detail: true,
          approval_status: 'pending_approval',
          date_preset: LIFETIME_DATE_PRESET
        },
        GOOGLE_PLATFORM
      )
    )
  }, [dispatch, partnershipRightsHolderId])

  useEffect(
    () => () => {
      dispatch(clearAssetGroups())
      dispatch(clearAds())
    },
    [dispatch]
  )

  return (
    <>
      <SocialAuthChecker
        platform={GOOGLE_PLATFORM}
        dataFetch={getInternalAdsData}
        adAccountId={googleAdAccountId}
        authFailureText="Please authenticate with Facebook to retrieve the list of ads."
      >
        <GoogleAdsPreviewList
          assetGroups={internalAssetGroups}
          ads={internalAds}
          noDataText="There are no ads waiting for approval."
        />
        <GoogleAssetGroupEdit />
        <AdGoogleEdit />
      </SocialAuthChecker>
    </>
  )
}

export default GoogleAdsSection
